export const WORKSHEET_TYPES = {
  NORMAL: '1',
  GENIE: '2',
  CUSTOMISED: '3',
  MASTER: '4', //! tagged as 'Starter' in `WorksheetCard.tsx`. may lead to confusion with Normal worksheet that's also tagged the same
  SEED: '5',
  CHALLENGE: '6',
  REVISION: '7',
  ASSESSMENT: '8',
  HOMEWORK: '9',
  SKILL_DECAYS: '10',
};

export const WORKSHEET_TIMER_MODE = {
  INIT: 0,
  WAITING_TO_START: 1,
  WAITING_TO_END: 2,
};

export const TOUR_TEMP_DISABLE = '999';

export const MOCK_EXAM_SHOW_SOLUTION_EXPLANATION_MARK_DATE =
  '2023-09-11 09:00:00';

export const WARNING_MAX_DAILY_WORKSHEETS_REACHED = 1;
export const WARNING_MAX_TOPICAL_WORKSHEETS_REACHED = 2;

export const INSUFFICIENT_WORKSHEET_ERROR_CODE = '019-02';
export const NEW_RECSYS_ERROR_LTA = '019-03';
